const assetMappings = `/asset-mappings`;
const mappedAssets = `/mapped-assets`;
const productUploads = `/product-uploads`;
const newProductUpload = `${productUploads}/create`;
const editProductUpload = `${productUploads}/:id`;

const pathToRoute = (path: string, params: Record<string, string | number>) => {
  let route = path;

  Object.keys(params).forEach((param) => {
    route = route.replace(`:${param}`, `${params[param]}`);
  });

  return route;
};

export const paths = {
  assetMappings,
  mappedAssets,
  productUploads,
  newProductUpload,
  editProductUpload,
};

export const routes = {
  getAssetMappingsRoute: () => assetMappings,
  getMappedAssetsRoute: () => mappedAssets,
  getProductUploadsRoute: () => productUploads,
  getNewUploadRoute: () => newProductUpload,
  getEditUploadRoute: (id: string) => pathToRoute(editProductUpload, { id }),
};
